import { render, staticRenderFns } from "./unmet_prerequisites_block.vue?vue&type=template&id=6d6f9e95&"
import script from "./unmet_prerequisites_block.vue?vue&type=script&lang=js&"
export * from "./unmet_prerequisites_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports